var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-main"},[_c('div',{staticClass:"page-top"},[_vm._v("page-top")]),_c('div',{staticClass:"page-cont clearfix"},[_c('div',{staticClass:"page-left"},[_vm._v("page-left")]),_c('div',{staticClass:"page-right"},[_vm._v("page-right")])])])
}]

export { render, staticRenderFns }